<template>
    <div class="card ">
        <div class="card-header">
            <h3>{{ lang.bssu_setup_title }}</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" v-for="(i, idx) in menuTab" :key="'item' + idx">
                            <a href="#" @click.prevent="chosseTab(i)"
                                :class="['nav-link', (tabSelected == i.val) ? 'active' : '']">
                                {{ i.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row mt-3" v-if="tabSelected == 'categories'">
                <div class="col-12">
                    <categories-bStore ></categories-bStore>
                </div>
            </div>
            <div class="row mt-3" v-if="tabSelected == 'noti'">
                <div class="col-12">
                    <noti-bStore :value="infoSetting" @save="set_bStoreInfo" @cancel="onCancel"></noti-bStore>
                </div>
            </div>
            <div class="row mt-3" v-if="tabSelected == 'orders'">
                <div class="col-12">
                    <order-setting :value="infoSetting" @save="set_bStoreInfo" @cancel="onCancel"></order-setting>
                </div>
            </div>
            <div class="row mt-3" v-if="tabSelected == 'booking'">
                <div class="col-12">
                    <booking-setting :value="infoSetting" @save="set_bStoreInfo" @cancel="onCancel"></booking-setting>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import categories_bStore from "./bStore_setup_categories.vue";
import bStore_noti from "./bStore_setup_noti.vue";
import OrderSetting from "./bStore_setup_order.vue";
import booking_setting from "./bStore_setup_booking.vue";
export default {
    components: {
        'categories-bStore': categories_bStore,
        'noti-bStore': bStore_noti,
        'order-setting': OrderSetting,
        'booking-setting': booking_setting,
    },
    data(){
        return {
            lang: {
                bssu_setup_title: '',
                bssu_categories: '',
                bssu_orders: '',
                bssu_booking: '',
                bssu_notifications: '',
                bs_failed: '',
                bs_error: '',
                bs_could_not_save: '',
            },
            menuTab: [
                {name: '', val: 'categories'},
                {name: '', val: 'orders'},
                {name: '', val: 'booking'},
                {name: '', val: 'noti'},
            ],
            tabSelected: null,
            apis: null,
            infoSetting: {},
            pusher_id: null,
        };
    },
    created(){
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.menuTab[0].name = this.lang.bssu_categories;
        this.menuTab[1].name = this.lang.bssu_orders;
        this.menuTab[2].name = this.lang.bssu_booking;
        this.menuTab[3].name = this.lang.bssu_notifications;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        this.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection) ? pusher.connection.socket_id : null;
        this.get_bStoreInfo()
    },
    methods: {
        chosseTab(i){
            let t = this;
            t.tabSelected = i.val;
            t.$store.commit('ModApps/Marketea/set_menuTab_bStore', i.val);
            setTimeout(() => {
                // t.$emit('clickAction', {name: i.val, data: []})
            }, 100);
        },
        onCancel(){
            // Close modal lateral
            this.$parent.close();
        },
        get_bStoreInfo(){
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(2)// getInfo
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                t.$store.commit("core/setLoadingModal", false);
                if (response.data.status) {
                    this.infoSetting = response.data.info || {};
                }
                t.tabSelected = t.$store.getters['ModApps/Marketea/is_menuTab_bStore'] || 'categories';
            })
            .catch((error) => {
                console.log(error);
                t.$store.commit("core/setLoadingModal", false);
                t.tabSelected = t.$store.getters['ModApps/Marketea/is_menuTab_bStore'] || 'categories';
            });
        },
        set_bStoreInfo(payload){
            let t = this;
            t.btnSend= true;
            console.log('payload', payload)
            let sendData = {
                user_id: window.master_client,
                org_id: window.localorgdata,
                email: payload.email || this.infoSetting.email || '',
                email_enabled: payload.email_enabled != null ? (payload.email_enabled ? 1 : 0) : (this.infoSetting.email_enabled ? 1 : 0),
                pref_phone: payload.pref_phone || this.infoSetting.pref_phone || '+1',
                phone: payload.phone || this.infoSetting.phone || '',
                phone_enabled: payload.phone_enabled != null ? (payload.phone_enabled ? 1 : 0) : (this.infoSetting.phone_enabled ? 1 : 0),
                autoresponse_sms: payload.autoresponse_sms != null ? (payload.autoresponse_sms ? 1 : 0) : (this.infoSetting.autoresponse_sms ? 1 : 0),
                contact_btn_text: payload.contact_btn_text || this.infoSetting.contact_btn_text || 'Contact',
                // mostrar btn ws solo si el campo ${phone} tiene un numero de telefono registrado
                show_btn_ws: payload.show_btn_ws != null ? (payload.show_btn_ws && payload.phone.length >0 ? 1 : 0) : (this.infoSetting.show_btn_ws ? 1 : 0),
                text_ws: payload.text_ws || this.infoSetting.text_ws || "I'm interested in the product: *{{product_name}}* from your store.",
                tax_percent: payload.tax_percent != null ? payload.tax_percent : this.infoSetting.tax_percent || 0,
                tax_enabled: payload.tax_enabled != null ? (payload.tax_enabled ? 1 : 0) : (this.infoSetting.tax_enabled ? 1 : 0),
                delivery_fee: payload.delivery_fee != null ? payload.delivery_fee : this.infoSetting.delivery_fee || 0,
                delivery_enabled: payload.delivery_enabled != null ? (payload.delivery_enabled ? 1 : 0) : (this.infoSetting.delivery_enabled ? 1 : 0),
                booking_cal_enabled: payload.booking_cal_enabled != null ? (payload.booking_cal_enabled ? 1 : 0) : (this.infoSetting.booking_cal_enabled ? 1 : 0),
                schedule_enabled: payload.schedule_enabled != null ? (payload.schedule_enabled ? 1 : 0) : (this.infoSetting.schedule_enabled ? 1 : 0),
                schedule: payload.schedule || this.infoSetting.schedule,
                privacy_link: payload.privacy_link || this.infoSetting.privacy_link || '',
                terms_link: payload.terms_link || this.infoSetting.terms_link || '',
                return_link: payload.return_link || this.infoSetting.return_link || '',
                booking_note: payload.booking_note || this.infoSetting.booking_note || '',
                pusher_id: this.pusher_id,
            }
            t.$store.commit("core/setLoadingModal", true);
            let urlService = t.apis.set(10)// setInfo
            window.master.post(urlService, sendData)
            .then((response) => {
                console.log(urlService, response.data);
                t.$store.commit("core/setLoadingModal", false);
                if (!response.data.status) {
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_failed,
                        text: t.lang.bs_could_not_save,
                    });
                } else {
                    let setUpdate = response.data.update;
                    t.$store.commit('ModApps/Marketea/set_bStore_info', setUpdate);
                }
            })
            .catch((error) => {
                console.log(error);
                t.$store.commit("core/setLoadingModal", false);
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bs_could_not_save,
                });
            });
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            is_menuTab_bStore: "is_menuTab_bStore",
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
            this.menuTab[0].name = this.lang.bssu_categories;
            this.menuTab[1].name = this.lang.bssu_orders;
            this.menuTab[2].name = this.lang.bssu_booking;
            this.menuTab[3].name = this.lang.bssu_notifications;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
